import type { BaselineWithExperiencesEntry } from '@ninetailed/experience.js-utils-contentful';
import type { SingularBlock } from '~/utils/ninetailed/types';

export const hasExperiences = (
  entry: SingularBlock
): entry is BaselineWithExperiencesEntry => {
  return (
    (entry as BaselineWithExperiencesEntry).fields?.nt_experiences !== undefined
  );
};
